const LangChangePassword = {
  "changePassword._title": ["Change Password", "ĐỔI MẬT KHẨU"],
  "resetMyPassword._title": ["Reset Password", "RESET MẬT KHẨU"],
  "cancel._title": ["Cancel", "HUỶ"],
  "changePassword.form.label._currentPassword": [
    "Current Password",
    "Mật khẩu hiện tại"
  ],
  "changePassword.form.label._newPassword": ["New Password", "Mật khẩu mới"],
  "changePassword.form.label._confirmNewPassword": [
    "Confirm New Password",
    "Nhập lại mật khẩu mới"
  ]
};

export default LangChangePassword;



// WEBPACK FOOTER //
// ./src/resources/pages/LangChangePassword.js